export default __webpack_public_path__ + "static/media/check.46b060c0.svg";